/**
 * @auth 赖传峰
 * @date 2024/8/13
 * @desc 获取帮助中心的文章目录，使用缓存提升访问性能
 */
import { fetchContentNavigation, queryContent, ref, type Ref, useAsyncData } from '#imports'
import type { NavItem } from '@nuxt/content'
import _ from 'lodash'
import useHelpCenterLocale from '~/composables/useHelpCenterLocale'
import { RoutePath } from '~/types/enum'

export const isReadmeFile = (item: NavItem) => item._path.endsWith('/readme')
export const removeSortPrefix = (title: string) => title.replace(/^\d+\./, '')
const cache: Map<string, Ref<NavItem[]>> = new Map()
export default async (): Promise<Ref<NavItem[] | null>> => {
  const locale = useHelpCenterLocale()
  if (cache.has(locale)) return cache.get(locale) || ref(null)

  const { data } = await useAsyncData(
    'navigation',
    () => fetchContentNavigation(queryContent().where({ _locale: locale })),
    {
      transform: input =>
        input
          .find(el => el._path === RoutePath.HELP_CENTER)
          ?.children?.map(function getDirTitle(el): NavItem {
            // 每个目录下有一个 README.md 文件，标题是目录名称
            const children = el.children?.filter(_.negate(isReadmeFile)).map(getDirTitle)
            return {
              ...el,
              title: removeSortPrefix(el.children?.find(isReadmeFile)?.title || el.title),
              children,
              isArticle: !children?.length, // 当前路径是目录还是文章，可用于减少请求
            }
          }) || [],
    },
  )

  if (data.value) cache.set(locale, ref(data.value))

  return data
}
